import React from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames/bind';
import images from '~/assets/images';

import styles from './EmployeeID.module.scss';
import Greetings from '~/components/specific/greetings/Greetings';
import Time from '~/components/specific/time/Time';
import { BaseButton } from '~/components/specific';
import ButtonPrimary from '~/components/specific/buttonPrimary/ButtonPrimary';
import InputCode from '~/components/specific/inputCode/inputCode';
import DateTitle from '~/components/specific/dateTitle/DateTitle';
import { enterEmployeeID, posVersion } from '~/utils/constants/common';
import { STATION_TAG_CONTENT, dataNumberKeyboard, TITLE_GREETINGS_LOGIN } from '~/utils/constants/mockData';
import { KeyboardActionTextEnum, TypeButtonEnum, TypeDateEnum } from '~/utils/enum';
import { userRoute } from '~/utils/constants/route';

interface Props {}

const cx = classNames.bind(styles);

const EmployeeID = (props: Props) => {
  const navigate = useNavigate()

  const handleLoginClicked = () => {
    navigate(`${userRoute.base}`)
  };

  const handleBaseButtonClicked = () => {
    navigate(`${userRoute.base}${userRoute.welcome}`)
  };

  return (
    <div id='employeeID' className={cx('employee-id-container')}>
      <div className={cx('employee-id-banner')}>
        <div className={cx('employee-id-banner-header')}>
          <div className={cx('employee-id-banner-header-logo')}>
            <img src={images.logoMini} alt='logo' />
          </div>
        </div>

        <div className={cx('employee-id-banner-content')}>
          <div className={cx('employee-id-banner-greeting-wrapper')}>
            <Greetings title={TITLE_GREETINGS_LOGIN} />
          </div>
          <div className={cx('employee-id-banner-date-wrapper')}>
            <DateTitle type={TypeDateEnum.LOGIN} />
          </div>
          <div className={cx('employee-id-banner-time-wrapper')}>
            <Time isLogin />
          </div>
        </div>

        <div className={cx('employee-id-banner-footer')}>
          <div className={cx('employee-id-banner-footer-title')}>
            <div className={cx('employee-id-banner-footer-title-txt')}>{STATION_TAG_CONTENT}</div>
          </div>
        </div>
      </div>

      <div className={cx('employee-id-content')}>
        <form className={cx('employee-id-content-form')}>
          <div className={cx('employee-id-content-station-code')}>
            <InputCode title={enterEmployeeID}/>
          </div>
          {/* TODO: Check combine component button */}
          <div className={cx('employee-id-content-keyboard')}>
            {dataNumberKeyboard.slice(0, 9).map((number, index) => (
              <BaseButton key={index} title={number} isNumericOrder backgroundType1 />
            ))}
          </div>
          <div className={cx('employee-id-content-keyboard')}>
            <div className={cx('employee-id-content-keyboard-clear')}>
              <BaseButton title={KeyboardActionTextEnum.CLEAR} fontSize18 backgroundType1/>
            </div>
            <div className={cx('employee-id-content-keyboard-zero')}>
              <BaseButton title={dataNumberKeyboard[9]} isNumericOrder backgroundType1/>
            </div>
            <div className={cx('employee-id-content-keyboard-back')}>
              <BaseButton title={KeyboardActionTextEnum.BACK} onClick={handleBaseButtonClicked} fontSize18 backgroundType1/>
            </div>
          </div>

          <div className={cx('employee-id-content-actions')}>
            <BaseButton title={KeyboardActionTextEnum.CANCEL} onClick={handleBaseButtonClicked} fontSize20 backgroundType1/>
            <ButtonPrimary title={KeyboardActionTextEnum.LOGIN} type={TypeButtonEnum.LOGIN} action={handleLoginClicked}/>
          </div>
        </form>

        <div className={cx('employee-id-content-footer')}>{posVersion}</div>
      </div>
    </div>
  )
};

export default EmployeeID;